<template>
  <div>
    <skeleton-loader v-if="loading"> </skeleton-loader>
    <div v-else id="user-profile">
      <profile-header :header-data="ngoInfo" @tabChange="setActiveTab" />
      <section id="profile-info">
        <b-row>
          <b-col lg="9" cols="12" order="1" order-lg="2">
            <profile-post />
          </b-col>
          <b-col lg="3" cols="12" order="2">
            <profile-docs />
          </b-col>
        </b-row>
      </section>
    </div>
  </div>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";
import ProfileHeader from "./components/ProfileHeader.vue";
import ProfileDocs from "./components/ProfileDocs.vue";
import ProfilePost from "./components/ProfileBody.vue";
import SkeletonLoader from "./components/SkeletonLoader.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    BRow,
    BCol,
    ProfileHeader,
    ProfileDocs,
    ProfilePost,
    SkeletonLoader,
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  computed: {
    ...mapGetters("TempNgo", ["ngoInfo", "loading", "isValidated"]),
  },

  destroyed() {
    this.$store.commit("appConfig/UPDATE_NAV_MENU_HIDDEN", this.menuHidden);
  },
  created() {
    this.$store.commit("appConfig/UPDATE_NAV_MENU_HIDDEN", true);

    this.fetchNgoData();
  },
  methods: {
    ...mapActions("TempNgo", ["fetchNgoData"]),
    setActiveTab(tabIndex) {
      this.activeTab = tabIndex;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-profile.scss";
.labels-cont {
  .form-group,
  .info-cont {
    border: 1px solid rgb(235, 232, 232);
    border-radius: 5px;
    padding: 10px 15px;
  }
  label {
    background-color: var(--info);
    color: white;
    font-size: small;
    font-weight: bold;
    padding: 5px 8px;
    width: fit-content;
    border-radius: 5px;
  }
}
// .form-group {
//   label {
//     color: var(--white);
//     background-color: var(--info);
//     padding: 4px 6px;
//     width: fit-content;
//     border-radius: 5px;
//     font-weight: bold;
//   }
// }
</style>
